import {
    SEARCH_POSITION_TRACKER_SUCCESS,
    SEARCH_POSITION_TRACKER_LOADING,
  } from '../actions/SearchPositionTrackerAction';
  
  const initialState = {
    searchPositionTrackerData: null,
    isLoading: true,
  };
  
  const SearchPositionTracker = (state = initialState, action = {}) => {
    switch (action.type) {
      case SEARCH_POSITION_TRACKER_SUCCESS:
        return {
          ...state,
          searchPositionTrackerData: action.data,
          isLoading: false,
        };
      case SEARCH_POSITION_TRACKER_LOADING:
        return { ...state, isLoading: action.isLoading };
  
      default:
        return state;
    }
  };
  
  export default SearchPositionTracker;
  